import * as types from "./actionTypes";

export const getUserList = data => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_LIST_REQUEST,
    data: data
  };
};

export const getUserListSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_LIST_SUCCESS,
    data: data
  };
};

export const getUserListFailure = error => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_LIST_FAILURE,
    error
  };
};

export const checkPhoneNumber = data => {
  return {
    type: types.USER_MANAGEMENT_CHECK_PHONE_NUMBER_REQUEST,
    data: data
  };
};

export const checkPhoneNumberSuccess = (data, invitedPhoneNumber) => {
  return {
    type: types.USER_MANAGEMENT_CHECK_PHONE_NUMBER_SUCCESS,
    data: data,
    invitedPhoneNumber: invitedPhoneNumber
  };
};

export const checkPhoneNumberFailure = () => {
  return {
    type: types.USER_MANAGEMENT_CHECK_PHONE_NUMBER_FAILURE
  };
};

export const clearFetchedUserData = () => {
  return {
    type: types.USER_MANAGEMENT_CLEAR_FETCHED_USER_DATA
  };
};

export const invite = data => {
  return {
    type: types.USER_MANAGEMENT_INVITE_REQUEST,
    data: data
  };
};

export const inviteSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_INVITE_SUCCESS
  };
};

export const inviteFailure = () => {
  return {
    type: types.USER_MANAGEMENT_INVITE_FAILURE
  };
};

export const initInvite = data => {
  return {
    type: types.USER_MANAGEMENT_INIT_INVITE_REQUEST,
    data: data
  };
};

export const initInviteSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_INIT_INVITE_SUCCESS,
    data: data
  };
};

export const initInviteFailure = error => {
  return {
    type: types.USER_MANAGEMENT_INIT_INVITE_FAILURE,
    error
  };
};

export const clearFetchedInitInviteData = () => {
  return {
    type: types.USER_MANAGEMENT_CLEAR_FETCHED_INIT_INVITE_DATA
  };
};

export const saveLastSelectedTeams = data => {
  return {
    type: types.USER_MANAGEMENT_SAVE_LAST_SELECTED_TEAMS,
    data
  };
};

export const clearLastSelectedTeams = () => {
  return {
    type: types.USER_MANAGEMENT_CLEAR_LAST_SELECTED_TEAMS
  };
};

export const showUserProfile = userId => {
  return {
    type: types.USER_MANAGEMENT_SHOW_USER_PROFILE_REQUEST,
    userId: userId
  };
};

export const showUserProfileSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_SHOW_USER_PROFILE_SUCCESS,
    data: data
  };
};

export const showUserProfileFailure = error => {
  return {
    type: types.USER_MANAGEMENT_SHOW_USER_PROFILE_FAILURE,
    error
  };
};

export const showProjectProfile = projectId => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_PROFILE_REQUEST,
    projectId: projectId
  };
};

export const showProjectProfileSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_PROFILE_SUCCESS,
    data: data
  };
};

export const showProjectProfileFailure = error => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_PROFILE_FAILURE,
    error
  };
};

export const showProjectUserProfile = (userId, projectId) => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST,
    userId: userId,
    projectId: projectId
  };
};

export const showProjectUserProfileSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_SUCCESS,
    data: data
  };
};

export const showProjectUserProfileFailure = error => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_FAILURE,
    error
  };
};

export const showProjectUserProfileRequestClone = () => {
  return {
    type: types.USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST_CLONE
  };
};

export const convertAdminToManager = data => {
  return {
    type: types.USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_REQUEST,
    data: data
  };
};
export const convertAdminToManagerSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_SUCCESS
  };
};
export const convertAdminToManagerFailure = () => {
  return {
    type: types.USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_FAILURE
  };
};

export const convertManagerToAdmin = data => {
  return {
    type: types.USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_REQUEST,
    data: data
  };
};
export const convertManagerToAdminSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_SUCCESS
  };
};
export const convertManagerToAdminFailure = () => {
  return {
    type: types.USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_FAILURE
  };
};

export const reactivate = data => {
  return {
    type: types.USER_MANAGEMENT_REACTIVATE_REQUEST,
    data: data
  };
};
export const reactivateSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_REACTIVATE_SUCCESS
  };
};
export const reactivateFailure = () => {
  return {
    type: types.USER_MANAGEMENT_REACTIVATE_FAILURE
  };
};

export const deactivate = data => {
  return {
    type: types.USER_MANAGEMENT_DEACTIVATE_REQUEST,
    data: data
  };
};
export const deactivateSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_DEACTIVATE_SUCCESS
  };
};
export const deactivateFailure = () => {
  return {
    type: types.USER_MANAGEMENT_DEACTIVATE_FAILURE
  };
};

export const deleteInvitation = data => {
  return {
    type: types.USER_MANAGEMENT_DELETE_INVITATION_REQUEST,
    data: data
  };
};
export const deleteInvitationSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_DELETE_INVITATION_SUCCESS
  };
};
export const deleteInvitationFailure = () => {
  return {
    type: types.USER_MANAGEMENT_DELETE_INVITATION_FAILURE
  };
};

export const removeManagerFromTeam = data => {
  return {
    type: types.USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_REQUEST,
    data: data
  };
};
export const removeManagerFromTeamSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_SUCCESS
  };
};
export const removeManagerFromTeamFailure = () => {
  return {
    type: types.USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_FAILURE
  };
};

export const changeTeamPermissions = data => {
  return {
    type: types.USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_REQUEST,
    data: data
  };
};
export const changeTeamPermissionsSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_SUCCESS
  };
};
export const changeTeamPermissionsFailure = () => {
  return {
    type: types.USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_FAILURE
  };
};

export const inviteManagerToOtherTeams = data => {
  return {
    type: types.USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_REQUEST,
    data: data
  };
};
export const inviteManagerToOtherTeamsSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_SUCCESS
  };
};
export const inviteManagerToOtherTeamsFailure = () => {
  return {
    type: types.USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_FAILURE
  };
};

export const getUserAccountingCodes = data => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_REQUEST,
    data: data
  };
};
export const getUserAccountingCodesSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_SUCCESS,
    data
  };
};
export const getUserAccountingCodesFailure = error => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_FAILURE,
    error
  };
};

export const editUserAccountingCodes = data => {
  return {
    type: types.USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_REQUEST,
    data: data
  };
};
export const editUserAccountingCodesSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_SUCCESS
  };
};
export const editUserAccountingCodesFailure = () => {
  return {
    type: types.USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_FAILURE
  };
};

export const editUserImprestPaymentLimit = data => {
  return {
    type: types.USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_REQUEST,
    data: data
  };
};
export const editUserImprestPaymentLimitSuccess = () => {
  return {
    type: types.USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_SUCCESS
  };
};
export const editUserImprestPaymentLimitFailure = () => {
  return {
    type: types.USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_FAILURE
  };
};

export const getUserImprestPaymentLimit = data => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_REQUEST,
    data: data
  };
};
export const getUserImprestPaymentLimitSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_SUCCESS,
    data
  };
};
export const getUserImprestPaymentLimitFailure = error => {
  return {
    type: types.USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_FAILURE,
    error
  };
};
export const getSharedProjects = () => {
  return {
    type: types.USER_MANAGEMENT_GET_SHARED_PROJECTS_REQUEST
  };
};

export const getSharedProjectsSuccess = data => {
  return {
    type: types.USER_MANAGEMENT_GET_SHARED_PROJECTS_SUCCESS,
    data: data
  };
};

export const getSharedProjectsFailure = error => {
  return {
    type: types.USER_MANAGEMENT_GET_SHARED_PROJECTS_FAILURE,
    error
  };
};

export const showTeamManagementMenuModal = () => {
  return {
    type: types.USER_MANAGEMENT_SHOW_MENU_MODAL
  };
};

export const closeTeamManagementMenuModal = () => {
  return {
    type: types.USER_MANAGEMENT_CLOSE_MENU_MODAL
  };
};

export const setConfirm = data => {
  return {
    type: types.USER_MANAGEMENT_SET_CONFIRM_DATA,
    data: data
  };
};

export const closeConfirm = () => {
  return {
    type: types.USER_MANAGEMENT_CLOSE_CONFIRM
  };
};
